import React, { useEffect, useRef, useState, useContext } from "react";
import constants from '../../Components/Services/constant';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import Menu from "./Menu";
import Services from "./Services";
import Blogs from "./Blogs";
import Resevation from "./Reservation";
import Clients from "./Clients";
import { ApiService } from "../../Components/Services/apiservices";
import Modal from "react-bootstrap/Modal";
import DataContext from "../../Components/Elements/eventContext";
import Accordion from "react-bootstrap/Accordion";
import Testimonials from "./Testimonials";
import { Container, Row, Col } from "react-bootstrap";

let apiServices = new ApiService();
function Home() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [faqData, setfaqData] = useState([]);
  const [videoData, setvideoData] = useState([]);
  const [pageData, setPageData] = useState({});

  const didMountRef = useRef(true);

  const contextValues = useContext(DataContext);

  // ✅ Call it inside useEffect (outside the function)
  useEffect(() => {
    apiServices.getHomeFaqDataRequest().then((res) => {
      if (res.data.status === "success") {
        setfaqData(res.data.faqdata);
      }
    });
  }, []);
  useEffect(() => {
    apiServices.getVideoDataRequest().then((res) => {
      if (res.data.status === "success") {
        setvideoData(res.data.videodata);
      }
    });
  }, []);

  useEffect(() => {
    const dataString = { page_url: "home" };
    apiServices.pagePostRequest(dataString)
      .then((res) => {
        if (res.data.status === "success" && res.data.pageData) {
          setPageData(res.data.pageData);
        }
      })
      .catch((err) => {
        console.error("Error fetching home page data:", err);
      });
  }, []);

  const getEmbedUrl = (url) => {
    try {
      // handle YouTube short links (youtu.be)
      if (url.includes("youtu.be")) {
        const videoId = url.split("youtu.be/")[1].split("?")[0];
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // handle YouTube Shorts links
      if (url.includes("/shorts/")) {
        const videoId = url.split("/shorts/")[1].split("?")[0];
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // handle full YouTube URLs (watch?v=)
      if (url.includes("watch?v=")) {
        const videoId = url.split("watch?v=")[1].split("&")[0];
        return `https://www.youtube.com/embed/${videoId}`;
      }

      // fallback: return original URL
      return url;
    } catch {
      return url;
    }
  };

  return (
    <>
      <Header />
      <div className="hero-video-wrapper">
        <video
          className="hero-video-bg"
          src={pageData?.metadata?.hero_video ? `${constants.IMAGE_URL}${pageData.metadata.hero_video}` : "assets/video/London_Video.mp4"}
          autoPlay
          loop
          muted
          playsInline
        ></video>
        <div className="hero-video-overlay"></div>
        <div className="hero-content-centered">
          <p className="hero-small-title">{pageData?.metadata?.hero_small_title || 'CHOKHI DHANI'}</p>
          <h1 className="hero-main-title" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.hero_main_title || 'CELEBRATE THE EXOTIC<br/>FLAVOURS OF INDIA' }} />
        </div>
        <div className="hero-scroll-down">
          <a href="#about" aria-label="Scroll Down">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14M19 12l-7 7-7-7"/>
            </svg>
          </a>
        </div>
      </div>

      {/* Floating Sidebars */}
      <div className="floating-sidebar-right">
        <a href="/offers" className="floating-btn-offers">SPECIAL OFFERS</a>
      </div>

      <section className="about section-padding" data-scroll-index="1">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-30" data-animate-effect="fadeInUp">
              <span>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
              </span>
              <div className="section-subtitle">{pageData?.metadata?.about_subtitle || 'Welcome to Chokhi Dhani'}</div>
              {/* <h2 className="section-title">An Indian Culinary Adventure</h2> */}
              <h1 className="section-title">
                {pageData?.metadata?.about_title || 'Chokhi Dhani- Best Indian Restaurant in London UK'}
              </h1>
              {/* <h2>
                Chokhi Dhani has championed local culture and hospitality in
                India for over 30 years.
              </h2> */}
              <p>
                {pageData?.metadata?.about_description || 'Chokhi Dhani has championed local culture and hospitality in India for over 30 years. For over three decades, Chokhi Dhani has been the best Indian restaurant in London UK, preserving and promoting local culture and hospitality in India. We have brought the same vision and essence to London, blending Royal Indian Cuisine, vibrant atmosphere, and exceptional hospitality from the land of Maharajas. Our menu includes the best Indian food in London UK. It is a testament to the legendary royal cuisine of Rajasthan, while also showcasing an eclectic selection of dishes from across India.'}
              </p>
              <div className="d-flex align-items-center about-button">
                <div className="butn-dark me-3">
                  <a href="/reservations">
                    <span>Reservations</span>
                  </a>
                </div>
                <div className="reservations">
                  <div className="icon">
                    <span className="flaticon-call"></span>
                  </div>
                  <div className="text">
                    <a
                      href={
                        "tel:" + contextValues.settingData.admin_support_mobile
                      }
                      className="footer-contact-phone"
                    >
                      {contextValues.settingData.admin_support_mobile}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-md-3" data-animate-effect="fadeInUp">
              <img
                src={pageData?.metadata?.about_image_1 ? `${constants.IMAGE_URL}${pageData.metadata.about_image_1}` : "/assets/img/food/1_food.jpeg"}
                alt=""
                className="mt-90 mb-30"
              />
            </div>
            <div className="col col-md-3" data-animate-effect="fadeInUp">
              <img src={pageData?.metadata?.about_image_2 ? `${constants.IMAGE_URL}${pageData.metadata.about_image_2}` : "/assets/img/food/2_food.jpeg"} alt="" />
            </div>
          </div>
        </div>
      </section>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Body className="login-modal-content">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </Modal.Body>
      </Modal>
      <Menu />
      {/* <Pricing /> */}
      {/* <PromoVideo /> */}
      <Services />

      <Testimonials />
      {/* <Facilities /> */}

      {faqData && faqData.length > 0 && (
        <section className="faqs__ section-padding pt-0">
          <Container>
            <h2 className="text-center mb-4 section-title">
              Frequently Asked Questions
            </h2>

            <div
              className="accordion accordion-flush"
              id="accordionFlushExample"
            >
              {faqData.map((item, index) => {
                const collapseId = `flush-collapse-${index}`;
                const headingId = `flush-heading-${index}`;
                const isFirst = index === 0; // check if it's the first item

                return (
                  <div className="accordion-item" key={index}>
                    <h2 className="accordion-header" id={headingId}>
                      <button
                        className={`accordion-button ${isFirst ? "" : "collapsed"
                          }`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${collapseId}`}
                        aria-expanded={isFirst ? "true" : "false"}
                        aria-controls={collapseId}
                      >
                        {item?.faq_title}
                      </button>
                    </h2>
                    <div
                      id={collapseId}
                      className={`accordion-collapse collapse ${isFirst ? "show" : ""
                        }`}
                      aria-labelledby={headingId}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div
                        className="accordion-body"
                        dangerouslySetInnerHTML={{
                          __html: item?.faq_description,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </Container>
        </section>
      )}

      {videoData && videoData.length > 0 && (
        <section className="svys section-padding">
          <Container>
            <h2 className="text-center mb-4 section-title">
              Some Videos Youtube Shorts
            </h2>
            <Row>
              {videoData.map((video, index) => (
                <Col md={4} sm={6} key={index}>
                  <div>
                    <iframe
                      className="w-100"
                      height="300"
                      src={getEmbedUrl(video.video_url)}
                      title={video.video_name}
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      )}

      <Blogs />
      <Resevation />
      <Clients />

      <Footer />
    </>
  );
}

export default Home;
